import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            POST /spaces/ <b>(DEPRECATED)</b>
          </h1>
        </div>
        <p>Create a new space.</p>
        <h2>URL Parameters</h2>
        <p>None.</p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>cid</td>
                <td>User ID of the Space's creator</td>
                <td>String</td>
                <td>Required</td>
                <td />
              </tr>
              <tr>
                <td>title</td>
                <td>Name of the space to be created</td>
                <td>String</td>
                <td>Required</td>
                <td />
              </tr>
              <tr>
                <td>description</td>
                <td>A description of the Space</td>
                <td>String</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>members</td>
                <td>Member data for members of the Space</td>
                <td>Array of member objects</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>PERM_TOPIC_CREATE</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">POST https://spacesapis.avayacloud.com/api/spaces/</pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h4>Body</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"cid": "5890b1243bab0e18ff044943",{"\n"}
          {"  "}"title": "space title2",{"\n"}
          {"  "}"description": "space desc2",{"\n"}
          {"  "}"members": [{"\n"}
          {"    "}
          {"{"}
          {"\n"}
          {"      "}"member": "5890b1243bab0e18ff044943",{"\n"}
          {"      "}"memberType": "userId",{"\n"}
          {"      "}"role": "admin",{"\n"}
          {"      "}"joinTime": "2017-03-14T20:13:56.727Z",{"\n"}
          {"      "}"username": "patrickhan@esna.com",{"\n"}
          {"      "}"displayname": "Patrick-123 Han-han",{"\n"}
          {"      "}"picture_url":
          "https://www.onesna.com/norevimages/noimage.jpg"{"      "}
          {"\n"}
          {"    "}
          {"}"}
          {"\n"}
          {"  "}]{"\n"}
          {"}"}
          {"\n"}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"cid": "5890b1243bab0e18ff044943",{"\n"}
          {"  "}"title": "space title2",{"\n"}
          {"  "}"description": "space desc2",{"\n"}
          {"  "}"_id": "590265a0c284716066e5ea3f",{"\n"}
          {"  "}"restrict": [],{"\n"}
          {"  "}"status": 0,{"\n"}
          {"  "}"members": [{"\n"}
          {"    "}
          {"{"}
          {"\n"}
          {"      "}"member": "5890b1243bab0e18ff044943",{"\n"}
          {"      "}"memberType": "userId",{"\n"}
          {"      "}"role": "admin",{"\n"}
          {"      "}"joinTime": "2017-03-14T20:13:56.727Z",{"\n"}
          {"      "}"username": "patrickhan@esna.com",{"\n"}
          {"      "}"displayname": "Patrick-123 Han-han",{"\n"}
          {"      "}"picture_url":
          "https://www.onesna.com/norevimages/noimage.jpg"{"      "}
          {"\n"}
          {"    "}
          {"}"}
          {"\n"}
          {"  "}],{"\n"}
          {"  "}"parents": [],{"\n"}
          {"  "}"settings": {"{"}
          {"\n"}
          {"    "}"mdOpts": [],{"\n"}
          {"    "}"mdSrv": "ams"{"\n"}
          {"  "}
          {"}"},{"\n"}
          {"  "}"created": "2017-04-27T21:41:52.797Z",{"\n"}
          {"  "}"type": "group"{"\n"}
          {"}"}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
